import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import CustomStore from 'devextreme/data/custom_store';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';
import { AppState } from '../../../stores/app.state';
import { IStandingOrderSearch, StandingOrderViewModel } from '../../models/ocl/standing-order-view-model';
import { ObjectUtils } from '../../utils';
import { FusionAuthService } from '../fusion-auth';
import { UrlProviderService } from '../general';
import * as Moment from 'moment';

@Injectable({
    providedIn: 'root',
})
export class StandingOrderService {
    constructor(private urlProvider: UrlProviderService,
                private store: Store<AppState>, private httpClient: HttpClient, private fusionAuthService: FusionAuthService) {
        this.getExtremeStore = this.getExtremeStore.bind(this);
    }

    public getExtremeStore(externalFilters: IStandingOrderSearch, clientIds?: number[]): CustomStore {
        const loadParams = {
            ...externalFilters,
            client: externalFilters.client ? externalFilters.client.id : undefined,
            unit: externalFilters.unit ? externalFilters.unit.id : undefined,
            patient: externalFilters.patient ? externalFilters.patient.id : undefined,
            testIds: externalFilters.testIds,
            clientIds
        };

        return createStore({
            key: 'id',
            loadUrl: `${this.urlProvider.ApiUrl}/standing-orders/extreme`,
            onBeforeSend: (operation, ajaxSettings) => {
                if (!ajaxSettings.headers) {
                    ajaxSettings.headers = {};
                }
                ajaxSettings.headers.authorization = `JWT ${this.fusionAuthService.getToken()}`;
                ajaxSettings.method = 'GET';
            },
            loadParams,
        });
    }

    public create(standingOrder: StandingOrderViewModel): Observable<StandingOrderViewModel> {
        standingOrder = ObjectUtils.capitalize(standingOrder) as StandingOrderViewModel;
        // @ts-ignore
        standingOrder.scheduler.startDate = Moment(standingOrder.scheduler.startDate).format('YYYY/MM/DD HH:mm:ss');
        return this.httpClient.post<StandingOrderViewModel>(`${this.urlProvider.ApiUrl}/standing-orders`, standingOrder);
    }

    public update(standingOrder: StandingOrderViewModel): Observable<StandingOrderViewModel> {
        standingOrder = ObjectUtils.capitalize(standingOrder) as StandingOrderViewModel;
        // @ts-ignore
        standingOrder.scheduler.startDate = Moment(standingOrder.scheduler.startDate).format('YYYY/MM/DD HH:mm:ss');
        return this.httpClient.put<StandingOrderViewModel>(`${this.urlProvider.ApiUrl}/standing-orders/${standingOrder.id}`, standingOrder);
    }

    public getStandingOrder(id: number): Observable<StandingOrderViewModel> {
        return this.httpClient.get<StandingOrderViewModel>(`${this.urlProvider.ApiUrl}/standing-orders/${id}`).pipe(retry(2));
    }

    public cancel(standingOrderIds: number[]) {
        let url = `/standing-orders/cancel?`;
        const ids: string[] = [];
        standingOrderIds.map(x => {
            ids.push(`ids=${x}`);
        });

        if (ids.length > 0) {
            url += ids.join('&');
        }

        return this.httpClient.put(`${this.urlProvider.ApiUrl}${url}`, {reportProgress: true});
    }
}
